import Action  from './baseActions';

export enum ReportResultActionTypes {
  EXECUTE_REPORT = 'report-result/execute',
  EXECUTING_REPORT = 'report-result/executing',
  EXECUTED_REPORT = 'report-result/executed',
  EXECUTING_REPORT_FAILED = 'report-result/executing_failed',

  /*
   * TODO: Maybe move it to noteflowActions?
   */
  RE_RUN_REPORT = 'report-result/re_run',
  RE_RUNNING_REPORT = 'report-result/re_running',
  RE_RUN_REPORT_SUCCESS = 'report-result/re_run_success',
  RE_RUN_REPORT_FAILED = 'report-result/re_run_failed',

  CHECK_REPORT_EXECUTION = 'report-result/check_report_execution',

  UNSET_REPORT_EXECUTION = 'report-result/unset_report_execution',
  UNSET_REPORT_EXECUTIONS = 'report-result/unset_report_executions', /* all executions */

  LOAD_REPORT_RESULT = 'report-result/load_report_result',
  LOADING_REPORT_RESULT = 'report-result/loading_report_result',
  LOADED_REPORT_RESULT = 'report-result/loaded_report_result',
  LOADING_REPORT_RESULT_FAILED = 'report-result/loading_report_result_failed',
}

// Interfaces
export interface ExecuteReportOptions {
}

export interface SendToMeOptions extends ExecuteReportOptions { // TODO - move it elsewhere
  send_to_me?: boolean;
  /*
   * If `email` or `slack` is false, don't send it to that destination
   */
  email?: string | false;
  slack?: string[] | false;
}

export interface ExecuteReportAction extends Action {
  type: ReportResultActionTypes.EXECUTE_REPORT;
  payload: {
    uid: string; // report identifier
    options?: ExecuteReportOptions;
  }
}

export interface ExecutingReportAction extends Action {
  type: ReportResultActionTypes.EXECUTING_REPORT;
}

export interface ExecutedReportAction extends Action {
  type: ReportResultActionTypes.EXECUTED_REPORT;
  payload: any;
}

export interface ExecutingReportFailedAction extends Action {
  type: ReportResultActionTypes.EXECUTING_REPORT_FAILED;
  payload: string; // report identifier
}

export interface ReRunReportAction extends Action {
  type: ReportResultActionTypes.RE_RUN_REPORT;
  payload: {
    uid: string; // report identifier
    flowRunId: string;
    taskRunIds: string[];
    taskRunParentId?: string;
  }
}

export interface ReRunningReportAction extends Action {
  type: ReportResultActionTypes.RE_RUNNING_REPORT;
}

export interface ReRunReportSuccessAction extends Action {
  type: ReportResultActionTypes.RE_RUN_REPORT_SUCCESS;
  payload: any;
}

export interface ReRunReportFailedAction extends Action {
  type: ReportResultActionTypes.RE_RUN_REPORT_FAILED;
  payload: string; // report identifier
}

export interface CheckReportExecution extends Action {
  type: ReportResultActionTypes.CHECK_REPORT_EXECUTION;
  payload: {
    uid: string; // report identifier
    resultId: string;
    counter: number; // safety check; check until,
  };
}

export interface UnsetReportExecution extends Action {
  type: ReportResultActionTypes.UNSET_REPORT_EXECUTION;
  payload: string;
}

export interface UnsetReportExecutions extends Action {
  type: ReportResultActionTypes.UNSET_REPORT_EXECUTIONS; /* all executions */
}

export interface LoadReportResultAction extends Action {
  type: ReportResultActionTypes.LOAD_REPORT_RESULT;
  payload: {
    uid: string;
    resultId: string;
  }
}

export interface LoadingReportResultAction extends Action {
  type: ReportResultActionTypes.LOADING_REPORT_RESULT;
}

export interface LoadedReportResultAction extends Action {
  type: ReportResultActionTypes.LOADED_REPORT_RESULT;
  payload: any;
}

export interface LoadingReportResultFailedAction extends Action {
  type: ReportResultActionTypes.LOADING_REPORT_RESULT_FAILED;
}

// Functions

export function executeReport(uid: string, options?: ExecuteReportOptions): ExecuteReportAction {
  return {
    type: ReportResultActionTypes.EXECUTE_REPORT,
    payload: {
      uid,
      options,
    },
  };
}

export function executingReport(): ExecutingReportAction {
  return {
    type: ReportResultActionTypes.EXECUTING_REPORT,
  };
}

export function executedReport(result: any): ExecutedReportAction {
  return {
    type: ReportResultActionTypes.EXECUTED_REPORT,
    payload: result,
  };
}

export function executingReportFailed(uid: string): ExecutingReportFailedAction {
  return {
    type: ReportResultActionTypes.EXECUTING_REPORT_FAILED,
    payload: uid,
  };
}

export function reRunReport(
  uid: string,
  flowRunId: string,
  taskRunIds: string[],
  taskRunParentId?: string,
): ReRunReportAction {
  return {
    type: ReportResultActionTypes.RE_RUN_REPORT,
    payload: {
      uid,
      flowRunId,
      taskRunIds,
      taskRunParentId,
    },
  };
}

export function reRunningReport(): ReRunningReportAction {
  return {
    type: ReportResultActionTypes.RE_RUNNING_REPORT,
  };
}

export function reRunReportSuccess(result: any): ReRunReportSuccessAction {
  return {
    type: ReportResultActionTypes.RE_RUN_REPORT_SUCCESS,
    payload: result,
  };
}

export function reRunReportFailed(uid: string): ReRunReportFailedAction {
  return {
    type: ReportResultActionTypes.RE_RUN_REPORT_FAILED,
    payload: uid,
  };
}

export function checkReportExecution(
  uid: string,
  resultId: string,
  counter: number = 0,
): CheckReportExecution {
  return {
    type: ReportResultActionTypes.CHECK_REPORT_EXECUTION,
    payload: {
      uid,
      resultId,
      counter,
    }
  }
}

export function unsetReportExecution(uid: string): UnsetReportExecution {
  /*
   * unset executionStatus
   */
  return {
    type: ReportResultActionTypes.UNSET_REPORT_EXECUTION,
    payload: uid
  }
}

export function unsetReportExecutions(): UnsetReportExecutions {
  return {
    type: ReportResultActionTypes.UNSET_REPORT_EXECUTIONS,
  }
}

export function loadReportResult(uid: string, resultId: string): LoadReportResultAction {
  return {
    type: ReportResultActionTypes.LOAD_REPORT_RESULT,
    payload: {
      uid,
      resultId,
    }
  }
}

export function loadingReportResult(): LoadingReportResultAction {
  return {
    type: ReportResultActionTypes.LOADING_REPORT_RESULT
  }
}

export function loadedReportResult(uid: string, result: any): LoadedReportResultAction {
  return {
    type: ReportResultActionTypes.LOADED_REPORT_RESULT,
    payload: {
      uid, //
      result,
    }
  }
}

export function loadingReportResultFailed(): LoadingReportResultFailedAction {
  return {
    type: ReportResultActionTypes.LOADING_REPORT_RESULT_FAILED
  }
}

// Types

export type ReportResultActions =
  | ExecuteReportAction
  | ExecutingReportAction
  | ExecutedReportAction
  | ExecutingReportFailedAction
  | ReRunReportAction
  | ReRunningReportAction
  | ReRunReportSuccessAction
  | ReRunReportFailedAction
  | CheckReportExecution
  | UnsetReportExecution
  | UnsetReportExecutions
  | LoadReportResultAction
  | LoadingReportResultAction
  | LoadedReportResultAction
  | LoadingReportResultFailedAction;
